import { AlarmTypeGroupRequestDTO } from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useAddAlarmTypeGroup(onSuccess: () => void) {
  const url = `/v2/orm/alarmtype_groups`;

  const request = new Request(url, {
    method: 'POST',
  });

  return useAuthenticatedMutation<null, AlarmTypeGroupRequestDTO>(request, {
    onSuccessInvalidationKeys: [['alarm-type-groups']],
    onSuccess,
  });
}

export default useAddAlarmTypeGroup;
